"use client";

import { useEffect, useState } from "react";

export default function ScrollHeader({
  fb,
  mail,
}: {
  fb: string;
  mail: string;
}) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const target = document.getElementById("section-one-trigger");
    if (!target) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(!entry.isIntersecting);
      },
      { threshold: 0 }
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const el = document.getElementById("contact");
    if (!el) return;

    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  const scrollToTop = () => {
    const el = document.getElementById("banner-anchor");
    if (!el) return;

    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };
  return (
    <header
      className={`
        fixed inset-x-0 top-0
        z-header
        transition-all duration-500
        ease-[cubic-bezier(0.22,1,0.36,1)]
        ${visible ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"}
      `}
    >
      {/* GLASS BAR */}
      <div
        className="
          bg-black/60 backdrop-blur-lg
          border-b border-white/15
          shadow-[0_10px_30px_-15px_rgba(0,0,0,0.35)]
        "
      >
        <div
          className="
            max-w-7xl mx-auto
            px-6 md:px-16
            h-[60px] md:h-[70px] lg:h-[72px]
            grid grid-cols-[1fr_2fr_1fr] md:grid-cols-[1fr_3fr_1fr] items-center
          "
        >
          {/* LEFT */}
          <div className="flex items-center gap-3">
            {fb && mail && (
              <>
                <a
                  href={fb}
                  className="opacity-70 hover:opacity-100 transition"
                >
                  <img
                    src="/icons/fb_icon_white.svg"
                    className="h-5 md:h-6"
                    alt="fb"
                  />
                </a>
                <a
                  href={mail}
                  className="opacity-70 hover:opacity-100 transition"
                >
                  <img
                    src="/icons/email_icon_white.svg"
                    alt="email"
                    className="h-5 md:h-6"
                  />
                </a>
              </>
            )}
          </div>

          {/* CENTER LOGO */}
          <div className="flex justify-center">
            <img
              src="/logos/logo_white_with_name_hori.png"
              alt="Logo"
              className="
    h-8 md:h-14 lg:h-18
    cursor-pointer
    select-none
  "
              onClick={scrollToTop}
            />
          </div>

          {/* RIGHT */}
          <div className="flex items-center justify-end gap-6">
            <button
              type="button"
              onClick={scrollToContact}
              className="
                text-white/90
                text-[10px] md:text-xs
                tracking-[0.25em] md:tracking-[0.3em]
                hover:text-white transition
                cursor-pointer
              "
            >
              LIÊN HỆ
            </button>

            {/* <LanguageDropdownModern /> */}
          </div>
        </div>
      </div>
    </header>
  );
}
